import type { WrappedFieldMetaProps } from 'redux-form';

const hasInputError = ({ touched, submitFailed, dirty, error }: WrappedFieldMetaProps): boolean =>
    error && touched && (submitFailed || dirty);

export default hasInputError;
